import Link from 'next/link'
import { useRouter } from 'next/router'
import styled, { css } from 'styled-components'
import {
  COMPANY_INFO_TABS,
  getCompanyInfoActiveTab,
} from '../../constants/detailTabs'

const CompanyInfoDetailTabs = () => {
  const router = useRouter()

  const activeTab = getCompanyInfoActiveTab(router.pathname)

  return (
    <StyledWrapper>
      {Object.entries(COMPANY_INFO_TABS).map(([tabKey, tab]) => {
        const href =
          tabKey === 'overview'
            ? `/company-info/${router.query.id}`
            : `/company-info/${router.query.id}/${tabKey}`

        return (
          <Link key={tabKey} href={href} shallow={false} scroll={false}>
            <a className={`tab-button ${activeTab === tabKey ? 'active' : ''}`}>
              <span className="tab-name">{tab.name}</span>
            </a>
          </Link>
        )
      })}
    </StyledWrapper>
  )
}

export default CompanyInfoDetailTabs

const StyledWrapper = styled.nav`
  ${({ theme }) => css`
    background-color: ${theme.background.bg_8};
    padding-top: 16px;
    height: 50px;
    display: flex;
    gap: 17px;
    overflow-x: auto;
    flex-wrap: nowrap;
    width: 100%;
    max-width: 100%;
    border-bottom: 1px solid ${theme.line.line_3};

    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }

    .tab-button {
      background: none;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 4px;
      position: relative;
      transition: all 0.2s ease;
      flex-shrink: 0;
      white-space: nowrap;
      padding-bottom: 11px;
      color: ${theme.color.text_1};

      &:first-child {
        margin-left: 20px;
      }
      &:last-child {
        margin-right: 20px;
      }

      &.active {
        .tab-name {
          color: ${theme.color.primary_2};
          font-weight: bold;
        }

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 2px;
          background-color: ${theme.color.primary_2};
        }
      }
    }

    .tab-name {
      font-size: 14px;
      font-weight: 500;
    }
  `}
`
